import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Lock, ArrowRight } from "lucide-react";
import NidaLogo from "../components/NidaLogo";
import { useI18n } from "../i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
    const { t } = useI18n();
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const onSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            const { data } = await axios.post(`${API}/admin/login`, { password });
            localStorage.setItem("nida_admin_token", data.token);
            navigate("/admin");
        } catch {
            setError(t("admin.wrong"));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            data-testid="admin-login-page"
            className="min-h-screen relative grid place-items-center overflow-hidden bg-ink-950 text-white"
        >
            <div className="pointer-events-none absolute inset-0 grid-bg opacity-30" />
            <div className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-[36rem] w-[36rem] rounded-full bg-brand/15 blur-[120px]" />

            <form
                onSubmit={onSubmit}
                data-testid="admin-login-form"
                className="relative card-surface gradient-border p-8 md:p-10 w-full max-w-md mx-6"
            >
                <div className="flex items-center justify-between mb-8">
                    <NidaLogo className="h-7" />
                    <span className="inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-white/[0.03] px-2.5 py-1 text-[10px] uppercase tracking-[0.2em] text-white/55">
                        <Lock className="h-3 w-3" />
                        Admin
                    </span>
                </div>

                <h1 className="text-2xl md:text-3xl font-semibold tracking-tight">{t("admin.login")}</h1>
                <p className="mt-2 text-sm text-white/55">CRM · Leads</p>

                <div className="mt-7">
                    <label className="text-xs uppercase tracking-wider text-white/50 mb-1.5 block">
                        {t("admin.password")}
                    </label>
                    <input
                        type="password"
                        data-testid="admin-password-input"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="w-full rounded-lg border border-white/10 bg-white/[0.03] px-4 py-3 text-sm text-white outline-none focus:border-brand transition"
                        autoFocus
                    />
                    {error && (
                        <p data-testid="admin-login-error" className="mt-2 text-xs text-red-400">
                            {error}
                        </p>
                    )}
                </div>

                <button
                    type="submit"
                    data-testid="admin-login-submit"
                    disabled={loading || !password}
                    className="btn-primary mt-6 w-full justify-center disabled:opacity-60"
                >
                    {loading ? "…" : t("admin.signIn")}
                    <ArrowRight className="h-4 w-4" />
                </button>
            </form>
        </div>
    );
}
